import React from "react";
import { motion, Variants } from "framer-motion";
import Section from "../components/Section";
import cls from './Hero.module.css';
import heroSatbayev from '../assets/hero-su1.png';

interface HeroProps {
  isActive: boolean;
}

// Настройка анимации букв (Эффект "Премиум-печать")
const letterVariants: Variants = {
  hidden: { 
    opacity: 0, 
    y: 20, 
    filter: "blur(10px)" // Мягкое появление из блюра
  },
  visible: {
    opacity: 1,
    y: 0,
    filter: "blur(0px)",
    transition: {
      duration: 0.8, // Каждая буква проявляется медленнее
      ease: "easeOut"
    }
  }
};

const chevronVariants: Variants = {
  hidden: { opacity: 0, y: -10 },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      delay: 2.5,
      duration: 0.8,
    }
  },
  bounce: {
    y: [0, 10, 0],
    opacity: [0.7, 1, 0.7], // Пульсация яркости
    scale: [0.95, 1.05, 0.95], // Легкое расширение света
    transition: {
      duration: 2, // Чуть медленнее для мягкости
      repeat: Infinity,
      ease: "easeInOut"
    }
  }
};


// Анимация для контейнеров текста (чтобы буквы шли друг за другом)
const containerVariants = (delay: number): Variants => ({
  hidden: { opacity: 0 },
  visible: {
    opacity: 1,
    transition: {
      staggerChildren: 0.15, // Скорость "печати" (0.15 — медленно и красиво)
      delayChildren: delay,  // Задержка перед началом печати всего слова
    }
  }
});

// Анимация для Сатпаева
const imageVariants: Variants = {
  hidden: { 
    opacity: 0, 
    x: -30, 
    scale: 0.95 
  },
  visible: {
    opacity: 1,
    x: 0,
    scale: 1,
    transition: {
      duration: 1.5,
      delay: 0.8, // Появляется в середине процесса
      ease: [0.16, 1, 0.3, 1] // Плавный финиш (expo out)
    }
  }
};

const Hero: React.FC<HeroProps> = ({ isActive }) => {
  const textQanysh = "ҚАНЫШ";
  const textAlemi = "ӘЛЕМІ";

  return (
    <Section isActive={isActive}>
      <div className={cls.heroSection}>
        
        {/* ВЕРХНИЙ ТЕКСТ (За головой) */}
        <motion.div
          className={cls.upperText}
          variants={containerVariants(0.3)} // Начинает почти сразу
          initial="hidden"
          animate={isActive ? "visible" : "hidden"}
        >
          {textQanysh.split("").map((char, index) => (
            <motion.span key={index} variants={letterVariants} className={cls.letter}>
              {char}
            </motion.span>
          ))}
        </motion.div>

        {/* ИЗОБРАЖЕНИЕ (Слой между текстами) */}
        <motion.img
          src={heroSatbayev}
          alt="Qanysh Satbayev"
          className={cls.heroSatbayevImg}
          variants={imageVariants}
          initial="hidden"
          animate={isActive ? "visible" : "hidden"}
        />

        {/* НИЖНИЙ ТЕКСТ (Поверх всего) */}
        <motion.div
          className={cls.lowerText}
          variants={containerVariants(1.5)} // Начинает после того, как "ҚАНЫШ" почти готов
          initial="hidden"
          animate={isActive ? "visible" : "hidden"}
        >
          {textAlemi.split("").map((char, index) => (
            <motion.span key={index} variants={letterVariants} className={cls.letter}>
              {char}
            </motion.span>
          ))}
        </motion.div>

        {/* Анимированный шеврон вниз */}
        <motion.div
          className={cls.scrollIndicator}
          variants={chevronVariants}
          initial="hidden"
          animate={isActive ? ["visible", "bounce"] : "hidden"}
        >
          <svg 
            viewBox="0 0 24 24" 
            fill="none" 
            xmlns="http://www.w3.org/2000/svg"
          >
            <path 
              d="M7 13L12 18L17 13M7 6L12 11L17 6" 
              strokeWidth="2" 
              strokeLinecap="round" 
              strokeLinejoin="round"
            />
          </svg>
        </motion.div>

      </div>
    </Section>
  );
};

export default Hero;